import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { collections } from "../../data/collections";
import { shopifyImg } from "../../utils/format";
import { container } from "../../utils/styles";
import { SectionHeader } from "../SectionHeader";
export function CategoryCards() {
  return <section aria-labelledby="categories-heading" className="bg-paper py-16 lg:py-24" data-id="element-127" data-mp="sxymfcxpznnv">
      <div className={container} data-id="element-128" data-mp="1goc54cuf0a5s">
        <SectionHeader id="categories-heading" title="Shop per categorie" link={{
        label: "Alle producten",
        to: "/shop"
      }} data-id="element-129" data-mp="1gpdiinywl8qo" />
        <ul className="mt-10 grid grid-cols-2 gap-x-4 gap-y-8 sm:gap-x-6 lg:grid-cols-4" data-id="element-130" data-mp="17uz3mmiac083">
          {collections.map(c => <li key={c.id} data-id="element-131" data-mp="1bv9d495ad8rp">
              <Link to={c.filter === "Alles" ? "/shop" : `/shop?categorie=${c.filter}`} className="group block" data-id="element-132" data-mp="1buhstuh52xgq">
                <div className="aspect-[4/5] overflow-hidden rounded-xl bg-sand" data-id="element-133" data-mp="1zk2a88xn9mnw">
                  <img src={shopifyImg(c.image, 900)} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-134" data-mp="24dwt5a5fdxlx" />
                </div>
                <div className="mt-4 flex items-center justify-between gap-3" data-id="element-135" data-mp="d2bxfhxp4xiu">
                  <span data-id="element-136" data-mp="ruvxg9pjuow2">
                    <span className="block text-[16px] font-medium text-ink lg:text-lg" data-id="element-137" data-mp="rv4aq2pl3w7s">{c.title}</span>
                    <span className="text-sm text-muted" data-id="element-138" data-mp="n0rmzgh2ryq8">{c.count} producten</span>
                  </span>
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sand text-ink transition-colors duration-200 group-hover:bg-ink group-hover:text-paper" data-id="element-139" data-mp="wse9wa2rzm8t">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-140" data-mp="1apt19kcla43f" />
                  </span>
                </div>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}